const REQUEST_ARTICLE = "REQUEST_ARTICLE";
const RECEIVE_ARTICLE = "RECEIVE_ARTICLE";
const REQUEST_PAGED_ARTICLES = "REQUEST_PAGED_ARTICLES";
const RECEIVE_PAGED_ARTICLES = "RECEIVE_PAGED_ARTICLES";

export {
    REQUEST_ARTICLE,
    RECEIVE_ARTICLE,
    REQUEST_PAGED_ARTICLES,
    RECEIVE_PAGED_ARTICLES
};



// WEBPACK FOOTER //
// ./src/actions/article/article.actions.js